import React from 'react';
import { Flex, Box, Button, theme } from '@xometry/xometry_loft';
import { css } from '@emotion/react';

const RestrictedPanel = (props: { redirectUrl: string }) => {
  const { redirectUrl } = props;

  const handleClick = () => {
    window.location.assign(redirectUrl);
  };
  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      width={['330px', '600px']}
      color={theme.colors.darkBlues[90]}
      fontSize={theme.fontSizes[2]}
    >
      <img
        src={`https://assets.xometry.com/images/Spot_Lock.svg`}
        css={css`
          width: 270px;
        `}
        alt="Restricted Access"
      />
      <Box fontSize={theme.fontSizes[4]} lineHeight={theme.fontSizes[5]}>
        Access Restricted
      </Box>
      <Flex flexDirection="column" alignItems="center" maxWidth="379px">
        <Box paddingTop={theme.space[2]}>
          You do not have access to the settings of this team. Contact an Admin
          to change your permissions if you need to access this page.
        </Box>
        <Button
          kind={theme.kind.primary}
          width={'100%'}
          marginTop={theme.space[6]}
          onClick={handleClick}
        >
          Return to Dashboard
        </Button>
      </Flex>
    </Flex>
  );
};

export default RestrictedPanel;
